import { SvgIcon } from '@mui/material';
import React from 'react';
import { BadgeVariant } from '../../types';
import { BadgeNotification } from './BadgeNotification';
import { ConditionalIconRenderer } from './ConditionalIconRenderer';

interface IConditionalBadgeNotificationRendererProps {
  utilityName: string;
  customMuiIcon?: typeof SvgIcon;
  badgeContent?: number;
  stringIcon?: string;
  badgeVariant?: BadgeVariant;
  top?: string | null;
  right?: string | null;
}

export const ConditionalBadgeNotificationRenderer = ({
  utilityName,
  customMuiIcon,
  stringIcon,
  badgeContent,
  badgeVariant,
  top,
  right
}: IConditionalBadgeNotificationRendererProps) => {
  const displayBadge = badgeVariant || badgeContent;

  return (
    <>
      {displayBadge ? (
        <BadgeNotification badgeVariant={badgeVariant} badgeContent={badgeContent} top={top} right={right}>
          <ConditionalIconRenderer customMuiIcon={customMuiIcon} stringIcon={stringIcon} utilityName={utilityName} />
        </BadgeNotification>
      ) : (
        <ConditionalIconRenderer customMuiIcon={customMuiIcon} stringIcon={stringIcon} utilityName={utilityName} />
      )}
    </>
  );
};
